import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { v7 as uuid } from "uuid";
import { Navbar } from "~/components/Navbar";
import { PrefabForm } from "~/components/PrefabForm";
import { db } from "~/utils/db";

function NewPrefab() {
  const navigate = useNavigate({ from: "/setting/prefab/new" });
  return (
    <>
      <Navbar
        title="新建插件集"
        enableBack
        navigationFallback={(go) => go({ to: "/setting/prefab" })}
      />
      <main className="padding">
        <PrefabForm
          isNew
          onSave={async (prefab) => {
            await db.prefabs.add({ ...prefab, id: uuid() });
          }}
          afterSubmit={() => navigate({ to: "/setting/prefab" })}
        />
      </main>
    </>
  );
}

export const Route = createFileRoute("/_main/setting/prefab/new")({
  component: NewPrefab,
});
